export function fmtTon(amount: number, digits: number = 2): string {
  return amount.toLocaleString('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function fmtPaddedTon(amount: number, intPad: number = 5): string {
  const [intPart, decPart = '00'] = amount.toFixed(2).split('.');
  return `${intPart.padStart(intPad, '0')}.${decPart}`;
}

export function fmtCellId(id: number): string {
  return '#' + id.toString().padStart(4, '0');
}

export function fmtAddress(addr: string): string {
  if (addr.length <= 12) return addr;
  return `${addr.slice(0, 6)}…${addr.slice(-4)}`;
}

export function fmtRelativeTime(ts: number): string {
  const diff = Date.now() - ts;
  if (diff < 60_000) return `${Math.floor(diff / 1000)}s ago`;
  if (diff < 3_600_000) return `${Math.floor(diff / 60_000)}m ago`;
  if (diff < 86_400_000) return `${Math.floor(diff / 3_600_000)}h ago`;
  return `${Math.floor(diff / 86_400_000)}d ago`;
}

export function fmtDaysAlive(bornAt: number): string {
  const d = (Date.now() - bornAt) / 86_400_000;
  if (d < 1) return `${(d * 24).toFixed(1)}h`;
  return `${d.toFixed(1)}d`;
}

export function fmtBigNum(n: number): string {
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(2) + 'M';
  if (n >= 1_000) return (n / 1_000).toFixed(2) + 'K';
  return n.toLocaleString('en-US');
}
